<template><div class="progress-bar" /></template>

<script lang="ts">
import { clamp } from 'ramda'
import { computed, defineComponent } from 'vue'

export default defineComponent({
  props: {
    value: {
      type: Number,
      required: true,
    },
  },
  setup(props) {
    return { progress: computed(() => `${clamp(0, 1, props.value) * 100}%`) }
  },
})
</script>

<style lang="postcss">
.progress-bar {
  overflow: hidden;
  width: 100%;
  height: 1rem;
  border-radius: 6px;
  background-color: rgb(184 184 185);

  &::after {
    display: block;
    width: v-bind(progress);
    min-width: 0;
    max-width: 100%;
    height: 100%;
    border-radius: inherit;
    background-color: #50e391;
    content: '';

    transition: 0.04s width ease-in-out;
  }
}
</style>
